<template>
  <div class="bg-white shadow-sm p-4">
    <b-row align-v="center">
      <b-col sm="12" md="auto" class="text-center">
        <avatar :src="team.photo" variant="team" size="7.5rem" class="m-4" />
      </b-col>
      <b-col>
        <div class="user-profile-name d-flex align-items-end mb-3">
          <h2 class="flex-grow-1 mt-3">{{team.name}}</h2>
          <div v-if="editable">
            <b-button variant="link" size="lg" @click.prevent="$emit('edit', team.id)">
              <edit-pen-icon :style="{fontSize: '1.5rem'}" />
            </b-button>
          </div>
        </div>
        <b-row>
          <b-col cols="12" md>
            <table class="user-profile-info-left">
              <tr v-if="manager">
                <td>Lead:</td>
                <td>
                  <b-link :to="{name: 'UserProfile', params: { userId: manager.profile.id }}">{{managerName}}</b-link>
                </td>
              </tr>
              <tr v-if="team.department">
                <td>Department:</td>
                <td>{{team.department}}</td>
              </tr>
              <tr v-if="team.service">
                <td>Service:</td>
                <td>{{team.service}}</td>
              </tr>
            </table>
          </b-col>
          <b-col cols="12" md>
            <div v-if="team.email"><b-icon-envelope-fill /> <b-link :href="`mailto:${team.email}`">{{team.email}}</b-link></div>
          </b-col>
        </b-row>
        <div class="mt-5">
          <kudos-thank :kudos="receivedKudos" :thank="receivedThank" title="The team has received" />
        </div>
      </b-col>
    </b-row>
    <slot />
  </div>
</template>

<script>
import { BIconEnvelopeFill } from 'bootstrap-vue'
import Avatar from '@/components/common/Avatar'
import { KudosThank } from '@/components/KudosList'
import EditPenIcon from '@/assets/images/edit-pen.svg'
import { userName } from '@/helpers/helpers'

export default {
  name: 'ProfileInfo',

  props: {
    team: {
      type: Object,
      required: true
    },

    teamKudos: {
      type: Object,
      default: () => ({})
    },

    members: {
      type: Object,
      default: () => ({})
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    computedMembers() {
      const members = {}
      this.team.members.forEach(member => {
        members[member.profile] = { ...member, profile: this.members[member.profile] }
      })
      return members
    },

    manager() {
      return Object.values(this.computedMembers).find(p => p.isManager)
    },

    managerName() {
      return userName(this.manager.profile)
    },

    receivedKudos() {
      return (this.teamKudos.received || []).reduce((out, value) => out + value.count, 0)
    },

    receivedThank() {
      return 0
    }
  },

  components: {
    BIconEnvelopeFill,
    Avatar,
    EditPenIcon,
    KudosThank
  }
}
</script>
